import React from 'react';
import ReactMarkdown, { type Options } from 'react-markdown';

// Renders every allowed block inline, so the subject stays on one line.
const PRenderer = (props: { children?: React.ReactNode }) => {
  return <span className={'break-words'}>{props.children}</span>;
};

const HRRenderer = () => {
  return <hr className={'border-0'} />;
};

export const MarkdownSubjectRenderer = ({ children, ...props }: Options) => {
  return (
    <ReactMarkdown
      allowedElements={['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'li', 'hr']}
      components={{
        p: PRenderer,
        img: () => null,
        video: () => null,
        picture: () => null,
        svg: () => null,
        h1: PRenderer,
        h2: PRenderer,
        h3: PRenderer,
        h4: PRenderer,
        h5: PRenderer,
        h6: PRenderer,
        ul: PRenderer,
        li: PRenderer,
        hr: HRRenderer,
      }}
      unwrapDisallowed={true}
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
};
